import { Box, Typography } from "@mui/material";
import { useState } from "react";
import SwitchFilter from "../../components/filters/SwitchFilter";

/**
 * Demo component for SwitchFilter
 * Shows usage with state management and label
 */
const SwitchFilterDemo = () => {
  const [appliedFilters, setAppliedFilters] = useState({ showActive: false });

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle1">SwitchFilter Example</Typography>
      <SwitchFilter
        filterName="showActive"
        label="Only Active Items"
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
      />
      <Typography variant="body2">
        Current value: {appliedFilters.showActive ? "Active" : "Inactive"}
      </Typography>
    </Box>
  );
};

export default SwitchFilterDemo;
